import React from "react";
import CountUp from "react-countup";
import { statsData } from "../../data/home";
import "./homeRedesign.css";

// Split a value like "2000+" / "15000+" / "11" into a number and a suffix
// so CountUp can animate the number while keeping the "+".
const parseCount = (value) => {
  const match = String(value).match(/^(\d+)(.*)$/);
  return {
    end: match ? parseInt(match[1], 10) : 0,
    suffix: match ? match[2] : "",
  };
};

const StatsStrip = ({ data }) => {
  const { items } = data || statsData;

  return (
    <section className="stats-ed" aria-label="NCET at a glance">
      <div className="container">
        <div className="stats-ed__grid">
          {items.map((stat, i) => {
            const { end, suffix } = parseCount(stat.count);
            const start = typeof stat.start === "number" ? stat.start : 0;
            return (
              <div className="stats-ed__item" key={i}>
                <span className="stats-ed__num">
                  <CountUp start={start} end={end} suffix={suffix} duration={2.2} />
                </span>
                <span className="stats-ed__label">{stat.title}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
